import { _, Grid } from "gridjs-react";
import { isFlagEnabled } from "js/utilities";
import { Trans, useTranslation } from "react-i18next";
import { getBillingTypeCodeMapping } from "js/formatting";

import Tooltip from "components/General/Tooltip";

export default function PaymentsHistoryGrid({ data }) {
  const { t } = useTranslation();
  return (
    <Grid
      data={data}
      columns={[
        {
          id: "paymentHistory-date-and-method",
          name: _(
            <>
              <p className="text-sm">
                {t(
                  "CustomerPaymentOverView-paymen-details-multi-grid-tab-payment-history-date"
                )}
              </p>
              <p className="text-xxs">
                {t(
                  "CustomerPaymentOverView-paymen-details-multi-grid-tab-payment-history-method"
                )}
              </p>
            </>
          ),
          data: (row) => row,
          formatter: (cell, row, el) => {
            return _(
              <>
                <p className="text-sm">{cell.postedDate}</p>
                <p className="text-xxs">
                  {getBillingTypeCodeMapping(cell?.paymentMethod)}
                </p>
              </>
            );
          },
          attributes: {
            role: "header",
          },
        },
        {
          id: "paymentHistory-type",
          name: _(
            <p className="text-center text-sm">
              {t(
                "CustomerPaymentOverView-paymen-details-multi-grid-tab-payment-history-status"
              )}
            </p>
          ),
          data: (row) => row,
          formatter: (cell, row, el) => {
            return _(
              <div className="flex justify-center items-center text-sm">
                <p>{cell.type}</p>
                {cell.type === "Returned" &&
                  isFlagEnabled("ENABLE_TOOLTIP_FOR_RETURNED_EFT_STATUS") && (
                    <Tooltip
                      xMargin="mx-0"
                      content={
                        <Trans
                          i18nKey="CustomerPaymentOverView-paymen-details-multi-grid-tab-payment-history-tooltip"
                          components={{
                            link1: <a href="/messages"></a>,
                          }}
                        />
                      }
                    />
                  )}
              </div>
            );
          },
          attributes: {
            role: "header",
          },
        },
        {
          id: "paymentHistory-amount",
          name: _(
            <p className="text-right text-sm">
              {t(
                "CustomerPaymentOverView-paymen-details-multi-grid-tab-payment-history-amount"
              )}
            </p>
          ),
          data: (row) => row,
          attributes: {
            role: "header",
          },
          formatter: (cell) => {
            return _(
              <p className="text-right text-sm">
                {cell.amount}
                {cell.type === "Disbursed" && " *"}
              </p>
            );
          },
        },
      ]}
      className={{
        table: "ui-grid-table-sm",
      }}
    />
  );
}
